import React, { ReactElement, useEffect, useState } from 'react'
import Card from 'components/Layout/Card'
import CardHeader from 'components/Layout/CardHeader'
import { HistoryLog } from 'types/campaign'
import { useTranslation } from 'react-i18next'
import FillingSpinner from 'components/FillingSpinner'
import './VoohCampaignHistory.scss'
import HistoryLogItem from '../../../Campaign/CampaignDetails/CampaignDetailsHistory/HistoryLogItem'
import { VoohCampaignForm } from '../../VoohCampaignForm/types'
import VoohCampaignDetailsService from '../service'
import { GetCampaignHistoryQueryData } from '../../../../api/voohCampaign/types'

type Props = {
  campaign: VoohCampaignForm
}

const VoohCampaignHistory: React.FC<Props> = ({ campaign }) => {
  const { t } = useTranslation()
  const [historyLogs, setHistoryLogs] = useState<HistoryLog[] | null>(null)

  useEffect(() => {
    VoohCampaignDetailsService.getVoohCampaignHistory(campaign.id).then(
      (historyResponse: GetCampaignHistoryQueryData) => {
        setHistoryLogs(historyResponse.data.voohCampaignHistory.nodes)
      }
    )
  }, [])

  const Logs = ({ logs }: { logs: HistoryLog[] }): ReactElement => (
    <>
      {logs.map((log, key) => (
        <HistoryLogItem
          creations={campaign.creations}
          historyLog={log}
          key={key}
        />
      ))}
    </>
  )

  const Body = (): ReactElement => {
    if (historyLogs) return <Logs logs={historyLogs} />

    if (!historyLogs) return <FillingSpinner />

    return <div className='CampaignDetailsHistory__no-data'>{t('campaignHistory.noData')}</div>
  }

  return (
    <Card className='CampaignDetailsHistory'>
      <CardHeader collapsed={false}>{t('campaignHistory.title')}</CardHeader>
      <div className='CampaignDetailsHistory__container'>{Body()}</div>
    </Card>
  )
}

export default VoohCampaignHistory
